import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { MainForm } from './main';
import { SidebarForm } from './sidebar';
import styles from './sidebar.module.css';

import { isHTMLBodyEmpty } from 'app/shared/utils/general';
import GmModal from 'app/shared/modal/modal';
import useValidator from 'hooks/validator';
import { transactionalValidationConfig } from 'app/shared/utils/form/validation/transactional';
import { useTransactionalService } from 'hooks/mailing/transactional';
import { useMailboxService } from 'hooks/users/mailbox';
import { toast } from 'react-toastify';

export const CreateTransactional = () => {
  const { id: transactional_id } = useParams();
  const history = useNavigate();
  const { tenant_id } = useSelector((state) => state.user_data);
  const { fetchMailboxes } = useMailboxService();
  const { createTransactional, fetchTransactionalById, searchTransactionals, updateTransactional } =
    useTransactionalService();
  const { errors, validateField, form_is_valid } = useValidator(transactionalValidationConfig);

  const [transactional, setTransactional] = useState({ tenant_id });
  const [mailbox, setMailbox] = useState({ emails: [] });
  const [loading, setLoading] = useState(false);
  const [show_details_modal, setShowDetailsModal] = useState(false);

  useEffect(() => {
    if (!isNaN(transactional_id)) {
      fetchTransactionalById(transactional_id).then(({ transactional }) => {
        Object.keys(transactional).forEach((key) => {
          validateField(key, transactional[key]);
        });
        validateField('title', transactional.name);
        setTransactional({ ...transactional, title: transactional.name });
      });
    }

    fetchMailboxes().then(({ mailboxes, error }) => {
      setMailbox(mailboxes[0] || { emails: [] });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAttributeChange = (attr_key, attr_value) => {
    validateField(attr_key, attr_value);
    setTransactional((transactional) => ({
      ...transactional,
      [attr_key]: attr_value
    }));
  };

  const handleTransactionalCreation = async (data) => {
    const payload = transactional_id ? data : { ...data, name: transactional.title };
    delete payload.title;

    const result = transactional_id
      ? await updateTransactional(transactional_id, { data: payload })
      : await createTransactional({ data: payload });
    if (result) history('/transactionals');
  };

  const handleSave = async () => {
    const data = { ...transactional, name: transactional.title, tenant_id };
    if (loading) return;

    setLoading(true);
    const { transactionals } = await searchTransactionals('code', data.code);
    const t_id = isNaN(transactional_id) ? 0 : Number(transactional_id);
    const match = transactionals.find((t) => t.code === data.code && t.id !== t_id);
    if (match) return toast.error('Transactional code already taken.');
    await handleTransactionalCreation(data);
    setLoading(false);
  };

  const is_continue_disabled =
    loading ||
    !transactional.subject?.trim() ||
    !transactional.body ||
    isHTMLBodyEmpty(transactional.body);

  return (
    <>
      <MainForm
        titleValue={transactional.subject}
        value={transactional.body}
        onEditorChange={handleAttributeChange}
        onContinue={() => setShowDetailsModal(true)}
        onTitleChange={(v) => handleAttributeChange('subject', v)}
        is_continue_disabled={is_continue_disabled}
      />

      <GmModal
        bodyClassName={styles.detailsModal}
        show_header={false}
        show_modal={show_details_modal}
        onClose={() => setShowDetailsModal(false)}
        position="right"
      >
        <SidebarForm
          transactional={transactional}
          onChange={handleAttributeChange}
          mailbox={mailbox}
          setMailbox={setMailbox}
          errors={errors}
          onSave={handleSave}
          is_saving={loading}
          is_save_disabled={!form_is_valid}
        />
      </GmModal>
    </>
  );
};
